import script from "./AppMultipleRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMultipleRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./AppMultipleRadioGroup.vue?vue&type=style&index=0&id=5bb565e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb565e0"]])

export default __exports__